// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

// *** IntersectionObserver ***

// const elements = document.querySelectorAll(".msdw-animate");

// function check(entries) {
//   entries.map((entry) => {
//     if (entry.isIntersecting) {
//       entry.target.classList.add("msdw-animated");
//       observer.unobserve(entry.target);
//     }
//   });
// }

// const observer = new IntersectionObserver(check);

// elements.forEach((elem) => observer.observe(elem));


//
// =SLIDER (SLICK JS)
// --------------------------------------------------

// tab content
$('.msdw-slider').slick({
  asNavFor: '.msdw-slider-nav',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  adaptiveHeight: true,
  swipe: false,
});

// tab navigation
$('.msdw-slider-nav').slick({
  asNavFor: '.msdw-slider',
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  centerMode: true,
  swipe: true,
  dots: false,
  focusOnSelect: true,
  mobileFirst: true,
  arrows: false,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 599, // 600
      settings: {
        slidesToShow: 1,
        centerPadding: '150px',
        centerMode: true,
        variableWidth: false,
        infinite: true
      }
    },
    {
      breakpoint: 899, // 900
      settings: {
        slidesToShow: 4,
        centerPadding: '0px',
        centerMode: false,
        variableWidth: false,
        infinite: false,
        swipe: false,
      }
    },
  ]
});


//
// =MODAL
// --------------------------------------------------

const modal = document.querySelector('.msdw-dialog');
const modalOpenLinks = document.querySelectorAll('.msdw-modal-open');
const modalClose = document.getElementById('modalClose');

modalOpenLinks.forEach(el => {
  el.addEventListener('click', () => {
    modal.showModal();
    document.body.classList.add('jws-overflowYHidden');
  });
});

modalClose.addEventListener('click', () => {
  modal.close()
  document.body.classList.remove('jws-overflowYHidden');
});

window.addEventListener('click', (event) => {
  if (event.target == modal) {
    modal.close();
    document.body.classList.remove('jws-overflowYHidden');
  }
});
